import { IconUserGroupOutline } from '@zillow/constellation-icons';
import { Box, Heading, Icon, Modal, Paragraph, Tag, Text } from '@zillow/constellation-10';

import ModalFooter from '../../../Modal/ModalFooter';
import { type TagTone } from '../../../../utils/statusTagUtils';

type Props = {
  onClose: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inProgressModules: Array<Record<string, any>>;
};

const ReviewSecurityDepositMultiPolicyConfirmationModal = ({
  onClose,
  onCancel,
  onSubmit,
  inProgressModules,
}: Props) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={3}>Security Deposit</Heading>}
      footer={<ModalFooter onCancel={onCancel} cancelText="Back" submitText="Confirm" onSubmit={onSubmit} />}
      size={{ base: 'fullScreen', md: 'lg' }}
      body={
        <div data-testid="rental-protection-two-step-opt-in-review-security-deposit-multi-policy-confirmation-modal">
          <Box css={{ paddingInline: { base: '0', md: '600' }, paddingBlock: { base: '0', md: '800' } }}>
            <Heading level={4} fontFamily="heading-alt">
              Multiple policies in progress
            </Heading>
            <Paragraph css={{ marginBottom: '400' }}>
              When you select ‘Confirm’, we will update the security deposit for the following policies:
            </Paragraph>
            <Box
              css={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                padding: { base: '400', mdDown: '0' },
                gap: '200',
                borderRadius: '100',
                border: '1px solid {colors.border.subtle}',
              }}
            >
              <Box
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '600',
                  padding: { base: '400', mdDown: '0' },
                }}
              >
                {inProgressModules.length > 0 &&
                  inProgressModules.map((item, id: React.Key) => {
                    return (
                      <div key={id}>
                        <Box css={{ display: 'flex', alignItems: 'center', gap: { base: '200', mdDown: '0' } }}>
                          <Box css={{ display: 'flex', mdDown: { flex: '2' } }}>
                            <Text>{item.selector.description.text}</Text>
                          </Box>
                          <Box css={{ display: 'flex', mdDown: { flex: '1' } }}>
                            <Tag
                              size="sm"
                              tone={item.tagStatus as TagTone}
                              css={{ marginLeft: { base: '0', md: '200' }, marginTop: '100' }}
                            >
                              {item.tagText}
                            </Tag>
                          </Box>
                        </Box>
                        {item.selector?.secondaryDescription?.text && (
                          <Box css={{ display: 'flex', alignItems: 'center', gap: '600' }}>
                            {item.selector.secondaryDescription.text.includes('+ others') && (
                              <Icon css={{ color: 'text.neutral' }} size="sm" render={<IconUserGroupOutline />} />
                            )}
                            <Text css={{ color: 'gray.400' }}>{item.selector.secondaryDescription.text}</Text>
                          </Box>
                        )}
                      </div>
                    );
                  })}
              </Box>
            </Box>
          </Box>
        </div>
      }
    />
  );
};

export default ReviewSecurityDepositMultiPolicyConfirmationModal;
